import AR from './locales/ar/translation'
// import CS from './locales/cs/translation'
import DE from './locales/de/translation'
import EN from './locales/en/translation'
import ES from './locales/es/translation'
// import FA from './locales/fa/translation'
import FR from './locales/fr/translation'
import HI from './locales/hi/translation'
import ID from './locales/id/translation'
import IT from './locales/it/translation'
import JA from './locales/ja/translation'
import KO from './locales/ko/translation'
import MA from './locales/ma/translation'
// import NL from './locales/nl/translation'
// import PL from './locales/pl/translation'
// import PT from './locales/pt/translation'
import RU from './locales/ru/translation'
import TH from './locales/th/translation'
import TR from './locales/tr/translation'
// import UK from './locales/uk/translation'
import VI from './locales/vi/translation'
import ZH from './locales/zh/translation'
import ZH_HANT from './locales/zh-Hant/translation'

export default {
  en: { translation: EN },
  zh: { translation: ZH },
  ja: { translation: JA },
  ko: { translation: KO },
  ma: { translation: MA },
  fr: { translation: FR },
  de: { translation: DE },
  it: { translation: IT },
  es: { translation: ES },
  // pt: { translation: PT },
  ru: { translation: RU },
  ar: { translation: AR },
  hi: { translation: HI },
  tr: { translation: TR },
  vi: { translation: VI },
  id: { translation: ID },
  th: { translation: TH },
  // cs: { translation: CS },
  // fa: { translation: FA },
  // nl: { translation: NL },
  // pl: { translation: PL },
  // uk: { translation: UK },
  'zh-Hant': { translation: ZH_HANT },
}
